import ButterImage from '../../components/ButterImage'

type HeroProps = {
  readonly title: string
  readonly description: string
  readonly imageLocation: 'left' | 'right'
  readonly image?: string
  readonly imageDescription: string
  readonly linkUrl?: string
}

/**
 * This component renders a hero with a title, description and an image.
 * @param title title to render
 * @param image url of image to render
 * @param imageLocation location in the component where the image should be rendered
 * @param imageDescription image alt text
 * @param description description to render
 * @param linkUrl optional url to go to when the component is clicked on
 */
export default function Hero({
  title,
  image,
  imageDescription,
  imageLocation,
  description,
  linkUrl,
}: HeroProps) {
  const component = (
    <div
      style={{
        display: 'grid',
        justifyContent: 'center',
        gridTemplate: '"left middle right" 1fr / min-content max-content min-content',
      }}
    >
      <div>
        <h2>{title}</h2>
        <div dangerouslySetInnerHTML={{ __html: description }} />
      </div>
      {image && (
        <ButterImage
          height={300}
          width={500}
          objectFit='contain'
          src={image}
          style={{ gridArea: imageLocation }}
          alt={imageDescription}
        />
      )}
    </div>
  )

  return linkUrl === undefined || linkUrl.length === 0 ? (
    component
  ) : (
    <a href={linkUrl} style={{ textDecoration: 'none' }}>
      {component}
    </a>
  )
}
